// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-screen{
  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 32px);
  display:grid;
  place-items:center;
  padding:16px 0;
}

.login-language-select{
  flex:0 0 auto;
  margin-right:auto;
  padding:0;
  color:#0f172a;
}

.login-language-select select{
  border-color:#dbe8ff;
  border-radius:8px;
  background:#f8fbff;
}

@media (max-width: 560px){
  .login-language-select{
    width:100%;
    margin-right:0;
    justify-content:space-between;
  }
}

.login-wrap{
  width:min(980px, 100%);
  max-width: 980px;
  margin: 0 auto;
  border-radius: 26px;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16);
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  position: relative;
}

.login-wrap::before{
  content:"";
  position:absolute;
  inset:0;
  background:
    radial-gradient(circle at 20% 20%, rgba(59,130,246,0.18), transparent 55%),
    radial-gradient(circle at 80% 0%, rgba(14,165,233,0.15), transparent 45%),
    radial-gradient(circle at 80% 80%, rgba(59,130,246,0.12), transparent 55%);
  pointer-events:none;
}

.login-hero{
  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 48%, #ffffff 100%);
  padding: 24px 24px;
  color:#fff;
  position: relative;
  z-index: 1;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:18px;
}

.login-hero-left{ display:flex; align-items:center; gap:12px; }

.login-hero-icon{
  width:48px; height:48px; border-radius:14px; background:rgba(255,255,255,0.18);
  display:grid; place-items:center; font-size:22px;
  border:1px solid rgba(255,255,255,0.25);
  backdrop-filter: blur(6px);
}

.login-hero-title{ font-weight:900; font-size:22px; letter-spacing:0.2px; }

.login-hero-logo{
  display:block;
  width:auto;
  max-width:180px;
  max-height:54px;
  object-fit:contain;
  flex:0 0 auto;
}

.login-visual-band{
  height: clamp(336px, 42vw, 456px);
  margin: 14px 16px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 22px;
  background:
    radial-gradient(circle at 48% 35%, rgba(30,64,175,0.28), rgba(30,64,175,0) 42%),
    linear-gradient(180deg, #0b1220 0%, #0f172a 62%, #111827 100%);
  border-bottom: 1px solid rgba(148,163,184,0.28);
  box-shadow: inset 0 24px 52px rgba(15,23,42,0.38);
}

.login-particle-cloud{
  position:absolute;
  inset:0;
  cursor:grab;
  touch-action:none;
  -webkit-user-select:none;
          user-select:none;
}

.login-particle-cloud.is-dragging{
  cursor:grabbing;
}

.login-particle-cloud canvas{
  width:100%;
  height:100%;
  display:block;
}

.login-particle-cloud::after{
  content:"";
  position:absolute;
  top:50%;
  left:50%;
  width:min(286px, 36%);
  aspect-ratio:1 / 1;
  transform:translate(-50%, -50%);
  pointer-events:none;
  border:1px solid rgba(226,232,240,0.16);
  border-radius:999px;
  background:
    radial-gradient(
      circle at 50% 50%,
      rgba(226,232,240,0.055) 0%,
      rgba(226,232,240,0.025) 58%,
      rgba(226,232,240,0) 72%
    );
  box-shadow:
    inset 0 0 42px rgba(15,23,42,0.45),
    0 0 44px rgba(147,197,253,0.12);
}

.login-particle-cloud__label{
  position:absolute;
  top:50%;
  left:50%;
  z-index:3;
  transform:translate(-50%, -50%);
  pointer-events:none;
  color:#f8fafc;
  font-size:clamp(13px, 1.55vw, 19px);
  font-weight:900;
  letter-spacing:0.08em;
  text-transform:uppercase;
  text-align:center;
  white-space:nowrap;
  text-shadow:
    0 0 14px rgba(147,197,253,0.62),
    0 2px 8px rgba(15,23,42,0.95);
}

.login-particle-cloud--fallback{
  background:
    radial-gradient(circle at 35% 42%, rgba(248,250,252,0.74) 0 2px, transparent 3px),
    radial-gradient(circle at 64% 56%, rgba(147,197,253,0.66) 0 2px, transparent 3px),
    linear-gradient(180deg, #0b1220 0%, #111827 100%);
  background-size: 42px 42px, 54px 54px, auto;
}

.login-card{
  padding: 20px 22px 18px;
  background:#fff;
  position: relative;
  z-index: 1;
}

.login-section + .login-section{ margin-top: 12px; }

.section-head{
  display:flex; align-items:baseline; gap:10px; margin-bottom:8px;
}

.section-title{ font-weight:900; color:#0f172a; letter-spacing:0.2px; }

.provider-grid{
  display:grid; gap:10px;
}

@media (min-width: 680px){ .provider-grid{ grid-template-columns: 1fr 1fr; } }

.prov-card{
  text-align:left; width:100%;
  border:1px solid #dbe3f3; background:#f8fbff;
  border-radius:18px; padding:14px;
  display:flex; gap:12px; align-items:flex-start;
  cursor:pointer; transition: transform .08s, background .2s, border-color .2s, box-shadow .2s;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);
}

.prov-card:hover{ transform: translateY(-2px); background:#f1f6ff; }

.prov-card.active{
  background:#ffffff;
  border-color:#b9d4ff;
  box-shadow:0 0 0 4px rgba(59,130,246,0.15), 0 14px 30px rgba(15, 23, 42, 0.12);
}

.radio{
  width:18px;height:18px;border-radius:999px; border:2px solid #9ab7e6; margin-top:2px;
  position:relative; flex:0 0 18px; background:#fff;
}

.radio.on{ border-color:#1d4ed8; }

.radio.on::after{
  content:""; position:absolute; left:50%; top:50%;
  width:8px;height:8px; background:#1d4ed8; border-radius:999px;
  transform: translate(-50%,-50%);
}

.prov-text{ display:grid; gap:2px; }

.prov-label{ font-weight:800; color:#0f172a; }

.prov-url{ font-size:12px; color:#64748b; }

.custom-row{ position:relative; }

.custom-input{
  width:100%; padding:10px 44px 10px 12px;
  border:1px solid #e2e8f0; border-radius:14px; outline:none;
  background:#fff; color:var(--text);
}

.custom-input:focus{ border-color:#b9d4ff; box-shadow:0 0 0 4px rgba(59,130,246,0.15); }

.clear-btn{
  position:absolute; right:8px; top:50%; transform:translateY(-50%);
  width:34px; height:34px; border:none; border-radius:10px;
  background:#f1f5f9; color:#64748b; cursor:pointer;
}

.login-footer{
  display:flex; justify-content:flex-end; align-items:center; gap:10px; flex-wrap:wrap;
  margin-top: 16px;
}

.login-secondary,
.login-primary{
  display:inline-flex; align-items:center; gap:.55rem;
  border:none;
  padding:.75rem 1.3rem; border-radius:14px; font-weight:800;
  cursor:pointer;
}

.login-primary{
  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);
  color:#fff;
  box-shadow:0 12px 26px rgba(37,99,235,0.3);
}

.login-secondary{
  background:#f8fbff;
  color:#1d4ed8;
  border:1px solid #dbe8ff;
}

.login-secondary:hover{
  background:#eef5ff;
}

.login-primary:disabled,
.login-secondary:disabled{ opacity:.6; cursor:not-allowed; }

.login-modalOverlay{
  position:fixed;
  inset:0;
  z-index:1200;
  display:grid;
  place-items:center;
  padding:22px;
  background:rgba(15,23,42,0.46);
  backdrop-filter:blur(8px);
}

.login-modal{
  width:min(720px, 96vw);
  max-height:min(760px, 92vh);
  overflow:auto;
  border-radius:24px;
  background:#ffffff;
  border:1px solid #dbe3f3;
  box-shadow:0 28px 70px rgba(15,23,42,0.3);
}

.login-modal__head{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:18px;
  padding:20px 22px;
  color:#ffffff;
  background:linear-gradient(120deg, #0f172a 0%, #0b4ea2 55%, #1d4ed8 100%);
}

.login-modal__eyebrow{
  font-size:0.72rem;
  font-weight:900;
  text-transform:uppercase;
  letter-spacing:0.08em;
  opacity:0.86;
}

.login-modal__head h2{
  margin:5px 0 0;
  font-size:22px;
  line-height:1.15;
}

.login-modal__close{
  width:38px;
  height:38px;
  border-radius:12px;
  border:1px solid rgba(255,255,255,0.25);
  background:rgba(255,255,255,0.14);
  color:#ffffff;
  display:grid;
  place-items:center;
  cursor:pointer;
}

.login-accountForm{
  display:grid;
  gap:14px;
  padding:20px 22px 22px;
}

.login-modal__copy{
  margin:0;
  color:#475569;
  line-height:1.5;
}

.login-accountForm label{
  display:grid;
  gap:6px;
}

.login-accountForm label > span{
  color:#64748b;
  font-size:12px;
  font-weight:800;
}

.login-accountForm input[type="email"],
.login-accountForm input[type="password"]{
  width:100%;
  min-width:0;
  padding:11px 12px;
  border:1px solid #e2e8f0;
  border-radius:14px;
  background:#ffffff;
  color:#0f172a;
  outline:none;
}

.login-accountForm input[type="email"]:focus,
.login-accountForm input[type="password"]:focus{
  border-color:#b9d4ff;
  box-shadow:0 0 0 4px rgba(59,130,246,0.15);
}

.login-accountForm__check{
  display:flex !important;
  grid-template-columns:auto 1fr;
  align-items:center;
  gap:8px;
  color:#475569;
  font-weight:700;
}

.login-accountForm__check input{
  accent-color:#1d4ed8;
}

.login-modal__actions{
  display:flex;
  justify-content:flex-end;
  align-items:center;
  gap:10px;
  margin-top:2px;
}

.login-modal__error{
  padding:10px 12px;
  border-radius:12px;
  border:1px solid #fecaca;
  background:#fff1f2;
  color:#b42318;
  font-weight:800;
}

.login-registerModal{
  width:min(780px, 96vw);
}

.login-registerForm{
  display:grid;
  gap:16px;
  padding:20px 22px 22px;
}

.login-registerSteps{
  display:grid;
  grid-template-columns:repeat(3, minmax(0, 1fr));
  gap:8px;
}

.login-registerStep{
  display:flex;
  align-items:center;
  gap:8px;
  min-width:0;
  padding:9px 10px;
  border:1px solid #e2e8f0;
  border-radius:14px;
  background:#f8fafc;
  color:#64748b;
}

.login-registerStep span{
  width:24px;
  height:24px;
  border-radius:9px;
  display:grid;
  place-items:center;
  flex:0 0 24px;
  background:#e2e8f0;
  color:#475569;
  font-size:12px;
  font-weight:900;
}

.login-registerStep strong{
  min-width:0;
  overflow:hidden;
  text-overflow:ellipsis;
}

.login-registerStep.active{
  border-color:#b9d4ff;
  background:#f1f6ff;
  color:#0f172a;
}

.login-registerStep.active span,
.login-registerStep.complete span{
  background:#1d4ed8;
  color:#ffffff;
}

.login-registerPanel{
  display:grid;
  gap:14px;
}

.login-registerPanel label{
  display:grid;
  gap:6px;
}

.login-registerPanel label > span,
.login-registerPreview > span,
.login-registerResult > span{
  color:#64748b;
  font-size:12px;
  font-weight:800;
}

.login-registerPanel .login-accountForm__check > span{
  color:inherit;
  font-size:inherit;
  font-weight:inherit;
}

.login-registerPanel input[type="email"],
.login-registerPanel input[type="password"],
.login-registerPanel input[type="text"]{
  width:100%;
  min-width:0;
  padding:11px 12px;
  border:1px solid #e2e8f0;
  border-radius:14px;
  background:#ffffff;
  color:#0f172a;
  outline:none;
}

.login-registerPanel input[type="email"]:focus,
.login-registerPanel input[type="password"]:focus,
.login-registerPanel input[type="text"]:focus{
  border-color:#b9d4ff;
  box-shadow:0 0 0 4px rgba(59,130,246,0.15);
}

.login-registerPreview,
.login-registerResult{
  display:grid;
  gap:5px;
  padding:11px 12px;
  border:1px solid #dbeafe;
  border-radius:14px;
  background:#f8fbff;
  overflow-wrap:anywhere;
}

.login-registerPreview strong,
.login-registerResult a{
  color:#1d4ed8;
  font-weight:800;
}

.login-registerProgress{
  padding:10px 12px;
  border-radius:12px;
  border:1px solid #dbeafe;
  background:#f8fbff;
  color:#1d4ed8;
  font-weight:800;
}

.login-registerDone{
  justify-items:start;
  padding:4px 0;
}

.login-registerDone > svg{
  width:34px;
  height:34px;
  color:#047857;
}

.login-registerDone h3{
  margin:0;
  color:#0f172a;
  font-size:20px;
}

.login-registerDone p{
  margin:6px 0 0;
  color:#475569;
  line-height:1.5;
}

@media (max-width: 560px){
  .login-visual-band{
    height: 312px;
    margin: 12px;
    border-radius: 20px;
  }

  .login-registerSteps{
    grid-template-columns:1fr;
  }

  .login-footer,
  .login-modal__actions{
    align-items:stretch;
    flex-direction:column;
  }

  .login-primary,
  .login-secondary{
    justify-content:center;
    width:100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/LoginScreen.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,cAAc;IACd,6BAA6B;EAC/B;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP;;;8EAG4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA,kBAAkB,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE;;AAE9D;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,iCAAiC;EAC9E,YAAY,EAAE,kBAAkB,EAAE,cAAc;EAChD,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA,mBAAmB,eAAe,EAAE,cAAc,EAAE,oBAAoB,EAAE;;AAE1E;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB;;kEAEgE;EAChE,+CAA+C;EAC/C,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB;;;;;;KAMG;EACH;;mCAEiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB;;iCAE+B;AACjC;;AAEA;EACE;;;qDAGmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,iCAAiC,gBAAgB,EAAE;;AAEnD;EACE,YAAY,EAAE,oBAAoB,EAAE,QAAQ,EAAE,iBAAiB;AACjE;;AAEA,gBAAgB,eAAe,EAAE,aAAa,EAAE,oBAAoB,EAAE;;AAEtE;EACE,YAAY,EAAE,QAAQ;AACxB;;AAEA,2BAA2B,gBAAgB,8BAA8B,EAAE,EAAE;;AAE7E;EACE,eAAe,EAAE,UAAU;EAC3B,wBAAwB,EAAE,kBAAkB;EAC5C,kBAAkB,EAAE,YAAY;EAChC,YAAY,EAAE,QAAQ,EAAE,sBAAsB;EAC9C,cAAc,EAAE,4EAA4E;EAC5F,8CAA8C;AAChD;;AAEA,kBAAkB,2BAA2B,EAAE,kBAAkB,EAAE;;AAEnE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,8EAA8E;AAChF;;AAEA;EACE,UAAU,CAAC,WAAW,CAAC,mBAAmB,EAAE,wBAAwB,EAAE,cAAc;EACpF,iBAAiB,EAAE,aAAa,EAAE,eAAe;AACnD;;AAEA,WAAW,oBAAoB,EAAE;;AAEjC;EACE,UAAU,EAAE,iBAAiB,EAAE,QAAQ,EAAE,OAAO;EAChD,SAAS,CAAC,UAAU,EAAE,kBAAkB,EAAE,mBAAmB;EAC7D,+BAA+B;AACjC;;AAEA,YAAY,YAAY,EAAE,OAAO,EAAE;;AAEnC,aAAa,eAAe,EAAE,aAAa,EAAE;;AAE7C,WAAW,cAAc,EAAE,aAAa,EAAE;;AAE1C,aAAa,iBAAiB,EAAE;;AAEhC;EACE,UAAU,EAAE,2BAA2B;EACvC,wBAAwB,EAAE,kBAAkB,EAAE,YAAY;EAC1D,eAAe,EAAE,iBAAiB;AACpC;;AAEA,qBAAqB,oBAAoB,EAAE,0CAA0C,EAAE;;AAEvF;EACE,iBAAiB,EAAE,SAAS,EAAE,OAAO,EAAE,0BAA0B;EACjE,UAAU,EAAE,WAAW,EAAE,WAAW,EAAE,kBAAkB;EACxD,kBAAkB,EAAE,aAAa,EAAE,cAAc;AACnD;;AAEA;EACE,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,QAAQ,EAAE,cAAc;EACpF,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB,EAAE,kBAAkB,EAAE,UAAU;EACnD,WAAW;EACX,qBAAqB,EAAE,kBAAkB,EAAE,eAAe;EAC1D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;2BAC2B,UAAU,EAAE,kBAAkB,EAAE;;AAE3D;EACE,cAAc;EACd,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,yEAAyE;AAC3E;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;;;EAGE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;;EAEE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;;IAEE,sBAAsB;IACtB,UAAU;EACZ;AACF","sourcesContent":[".login-screen{\n  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 32px);\n  display:grid;\n  place-items:center;\n  padding:16px 0;\n}\n\n.login-language-select{\n  flex:0 0 auto;\n  margin-right:auto;\n  padding:0;\n  color:#0f172a;\n}\n\n.login-language-select select{\n  border-color:#dbe8ff;\n  border-radius:8px;\n  background:#f8fbff;\n}\n\n@media (max-width: 560px){\n  .login-language-select{\n    width:100%;\n    margin-right:0;\n    justify-content:space-between;\n  }\n}\n\n.login-wrap{\n  width:min(980px, 100%);\n  max-width: 980px;\n  margin: 0 auto;\n  border-radius: 26px;\n  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16);\n  overflow: hidden;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  position: relative;\n}\n\n.login-wrap::before{\n  content:\"\";\n  position:absolute;\n  inset:0;\n  background:\n    radial-gradient(circle at 20% 20%, rgba(59,130,246,0.18), transparent 55%),\n    radial-gradient(circle at 80% 0%, rgba(14,165,233,0.15), transparent 45%),\n    radial-gradient(circle at 80% 80%, rgba(59,130,246,0.12), transparent 55%);\n  pointer-events:none;\n}\n\n.login-hero{\n  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 48%, #ffffff 100%);\n  padding: 24px 24px;\n  color:#fff;\n  position: relative;\n  z-index: 1;\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:18px;\n}\n\n.login-hero-left{ display:flex; align-items:center; gap:12px; }\n\n.login-hero-icon{\n  width:48px; height:48px; border-radius:14px; background:rgba(255,255,255,0.18);\n  display:grid; place-items:center; font-size:22px;\n  border:1px solid rgba(255,255,255,0.25);\n  backdrop-filter: blur(6px);\n}\n\n.login-hero-title{ font-weight:900; font-size:22px; letter-spacing:0.2px; }\n\n.login-hero-logo{\n  display:block;\n  width:auto;\n  max-width:180px;\n  max-height:54px;\n  object-fit:contain;\n  flex:0 0 auto;\n}\n\n.login-visual-band{\n  height: clamp(336px, 42vw, 456px);\n  margin: 14px 16px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  border-radius: 22px;\n  background:\n    radial-gradient(circle at 48% 35%, rgba(30,64,175,0.28), rgba(30,64,175,0) 42%),\n    linear-gradient(180deg, #0b1220 0%, #0f172a 62%, #111827 100%);\n  border-bottom: 1px solid rgba(148,163,184,0.28);\n  box-shadow: inset 0 24px 52px rgba(15,23,42,0.38);\n}\n\n.login-particle-cloud{\n  position:absolute;\n  inset:0;\n  cursor:grab;\n  touch-action:none;\n  user-select:none;\n}\n\n.login-particle-cloud.is-dragging{\n  cursor:grabbing;\n}\n\n.login-particle-cloud canvas{\n  width:100%;\n  height:100%;\n  display:block;\n}\n\n.login-particle-cloud::after{\n  content:\"\";\n  position:absolute;\n  top:50%;\n  left:50%;\n  width:min(286px, 36%);\n  aspect-ratio:1 / 1;\n  transform:translate(-50%, -50%);\n  pointer-events:none;\n  border:1px solid rgba(226,232,240,0.16);\n  border-radius:999px;\n  background:\n    radial-gradient(\n      circle at 50% 50%,\n      rgba(226,232,240,0.055) 0%,\n      rgba(226,232,240,0.025) 58%,\n      rgba(226,232,240,0) 72%\n    );\n  box-shadow:\n    inset 0 0 42px rgba(15,23,42,0.45),\n    0 0 44px rgba(147,197,253,0.12);\n}\n\n.login-particle-cloud__label{\n  position:absolute;\n  top:50%;\n  left:50%;\n  z-index:3;\n  transform:translate(-50%, -50%);\n  pointer-events:none;\n  color:#f8fafc;\n  font-size:clamp(13px, 1.55vw, 19px);\n  font-weight:900;\n  letter-spacing:0.08em;\n  text-transform:uppercase;\n  text-align:center;\n  white-space:nowrap;\n  text-shadow:\n    0 0 14px rgba(147,197,253,0.62),\n    0 2px 8px rgba(15,23,42,0.95);\n}\n\n.login-particle-cloud--fallback{\n  background:\n    radial-gradient(circle at 35% 42%, rgba(248,250,252,0.74) 0 2px, transparent 3px),\n    radial-gradient(circle at 64% 56%, rgba(147,197,253,0.66) 0 2px, transparent 3px),\n    linear-gradient(180deg, #0b1220 0%, #111827 100%);\n  background-size: 42px 42px, 54px 54px, auto;\n}\n\n.login-card{\n  padding: 20px 22px 18px;\n  background:#fff;\n  position: relative;\n  z-index: 1;\n}\n\n.login-section + .login-section{ margin-top: 12px; }\n\n.section-head{\n  display:flex; align-items:baseline; gap:10px; margin-bottom:8px;\n}\n\n.section-title{ font-weight:900; color:#0f172a; letter-spacing:0.2px; }\n\n.provider-grid{\n  display:grid; gap:10px;\n}\n\n@media (min-width: 680px){ .provider-grid{ grid-template-columns: 1fr 1fr; } }\n\n.prov-card{\n  text-align:left; width:100%;\n  border:1px solid #dbe3f3; background:#f8fbff;\n  border-radius:18px; padding:14px;\n  display:flex; gap:12px; align-items:flex-start;\n  cursor:pointer; transition: transform .08s, background .2s, border-color .2s, box-shadow .2s;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);\n}\n\n.prov-card:hover{ transform: translateY(-2px); background:#f1f6ff; }\n\n.prov-card.active{\n  background:#ffffff;\n  border-color:#b9d4ff;\n  box-shadow:0 0 0 4px rgba(59,130,246,0.15), 0 14px 30px rgba(15, 23, 42, 0.12);\n}\n\n.radio{\n  width:18px;height:18px;border-radius:999px; border:2px solid #9ab7e6; margin-top:2px;\n  position:relative; flex:0 0 18px; background:#fff;\n}\n\n.radio.on{ border-color:#1d4ed8; }\n\n.radio.on::after{\n  content:\"\"; position:absolute; left:50%; top:50%;\n  width:8px;height:8px; background:#1d4ed8; border-radius:999px;\n  transform: translate(-50%,-50%);\n}\n\n.prov-text{ display:grid; gap:2px; }\n\n.prov-label{ font-weight:800; color:#0f172a; }\n\n.prov-url{ font-size:12px; color:#64748b; }\n\n.custom-row{ position:relative; }\n\n.custom-input{\n  width:100%; padding:10px 44px 10px 12px;\n  border:1px solid #e2e8f0; border-radius:14px; outline:none;\n  background:#fff; color:var(--text);\n}\n\n.custom-input:focus{ border-color:#b9d4ff; box-shadow:0 0 0 4px rgba(59,130,246,0.15); }\n\n.clear-btn{\n  position:absolute; right:8px; top:50%; transform:translateY(-50%);\n  width:34px; height:34px; border:none; border-radius:10px;\n  background:#f1f5f9; color:#64748b; cursor:pointer;\n}\n\n.login-footer{\n  display:flex; justify-content:flex-end; align-items:center; gap:10px; flex-wrap:wrap;\n  margin-top: 16px;\n}\n\n.login-secondary,\n.login-primary{\n  display:inline-flex; align-items:center; gap:.55rem;\n  border:none;\n  padding:.75rem 1.3rem; border-radius:14px; font-weight:800;\n  cursor:pointer;\n}\n\n.login-primary{\n  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);\n  color:#fff;\n  box-shadow:0 12px 26px rgba(37,99,235,0.3);\n}\n\n.login-secondary{\n  background:#f8fbff;\n  color:#1d4ed8;\n  border:1px solid #dbe8ff;\n}\n\n.login-secondary:hover{\n  background:#eef5ff;\n}\n\n.login-primary:disabled,\n.login-secondary:disabled{ opacity:.6; cursor:not-allowed; }\n\n.login-modalOverlay{\n  position:fixed;\n  inset:0;\n  z-index:1200;\n  display:grid;\n  place-items:center;\n  padding:22px;\n  background:rgba(15,23,42,0.46);\n  backdrop-filter:blur(8px);\n}\n\n.login-modal{\n  width:min(720px, 96vw);\n  max-height:min(760px, 92vh);\n  overflow:auto;\n  border-radius:24px;\n  background:#ffffff;\n  border:1px solid #dbe3f3;\n  box-shadow:0 28px 70px rgba(15,23,42,0.3);\n}\n\n.login-modal__head{\n  display:flex;\n  align-items:flex-start;\n  justify-content:space-between;\n  gap:18px;\n  padding:20px 22px;\n  color:#ffffff;\n  background:linear-gradient(120deg, #0f172a 0%, #0b4ea2 55%, #1d4ed8 100%);\n}\n\n.login-modal__eyebrow{\n  font-size:0.72rem;\n  font-weight:900;\n  text-transform:uppercase;\n  letter-spacing:0.08em;\n  opacity:0.86;\n}\n\n.login-modal__head h2{\n  margin:5px 0 0;\n  font-size:22px;\n  line-height:1.15;\n}\n\n.login-modal__close{\n  width:38px;\n  height:38px;\n  border-radius:12px;\n  border:1px solid rgba(255,255,255,0.25);\n  background:rgba(255,255,255,0.14);\n  color:#ffffff;\n  display:grid;\n  place-items:center;\n  cursor:pointer;\n}\n\n.login-accountForm{\n  display:grid;\n  gap:14px;\n  padding:20px 22px 22px;\n}\n\n.login-modal__copy{\n  margin:0;\n  color:#475569;\n  line-height:1.5;\n}\n\n.login-accountForm label{\n  display:grid;\n  gap:6px;\n}\n\n.login-accountForm label > span{\n  color:#64748b;\n  font-size:12px;\n  font-weight:800;\n}\n\n.login-accountForm input[type=\"email\"],\n.login-accountForm input[type=\"password\"]{\n  width:100%;\n  min-width:0;\n  padding:11px 12px;\n  border:1px solid #e2e8f0;\n  border-radius:14px;\n  background:#ffffff;\n  color:#0f172a;\n  outline:none;\n}\n\n.login-accountForm input[type=\"email\"]:focus,\n.login-accountForm input[type=\"password\"]:focus{\n  border-color:#b9d4ff;\n  box-shadow:0 0 0 4px rgba(59,130,246,0.15);\n}\n\n.login-accountForm__check{\n  display:flex !important;\n  grid-template-columns:auto 1fr;\n  align-items:center;\n  gap:8px;\n  color:#475569;\n  font-weight:700;\n}\n\n.login-accountForm__check input{\n  accent-color:#1d4ed8;\n}\n\n.login-modal__actions{\n  display:flex;\n  justify-content:flex-end;\n  align-items:center;\n  gap:10px;\n  margin-top:2px;\n}\n\n.login-modal__error{\n  padding:10px 12px;\n  border-radius:12px;\n  border:1px solid #fecaca;\n  background:#fff1f2;\n  color:#b42318;\n  font-weight:800;\n}\n\n.login-registerModal{\n  width:min(780px, 96vw);\n}\n\n.login-registerForm{\n  display:grid;\n  gap:16px;\n  padding:20px 22px 22px;\n}\n\n.login-registerSteps{\n  display:grid;\n  grid-template-columns:repeat(3, minmax(0, 1fr));\n  gap:8px;\n}\n\n.login-registerStep{\n  display:flex;\n  align-items:center;\n  gap:8px;\n  min-width:0;\n  padding:9px 10px;\n  border:1px solid #e2e8f0;\n  border-radius:14px;\n  background:#f8fafc;\n  color:#64748b;\n}\n\n.login-registerStep span{\n  width:24px;\n  height:24px;\n  border-radius:9px;\n  display:grid;\n  place-items:center;\n  flex:0 0 24px;\n  background:#e2e8f0;\n  color:#475569;\n  font-size:12px;\n  font-weight:900;\n}\n\n.login-registerStep strong{\n  min-width:0;\n  overflow:hidden;\n  text-overflow:ellipsis;\n}\n\n.login-registerStep.active{\n  border-color:#b9d4ff;\n  background:#f1f6ff;\n  color:#0f172a;\n}\n\n.login-registerStep.active span,\n.login-registerStep.complete span{\n  background:#1d4ed8;\n  color:#ffffff;\n}\n\n.login-registerPanel{\n  display:grid;\n  gap:14px;\n}\n\n.login-registerPanel label{\n  display:grid;\n  gap:6px;\n}\n\n.login-registerPanel label > span,\n.login-registerPreview > span,\n.login-registerResult > span{\n  color:#64748b;\n  font-size:12px;\n  font-weight:800;\n}\n\n.login-registerPanel .login-accountForm__check > span{\n  color:inherit;\n  font-size:inherit;\n  font-weight:inherit;\n}\n\n.login-registerPanel input[type=\"email\"],\n.login-registerPanel input[type=\"password\"],\n.login-registerPanel input[type=\"text\"]{\n  width:100%;\n  min-width:0;\n  padding:11px 12px;\n  border:1px solid #e2e8f0;\n  border-radius:14px;\n  background:#ffffff;\n  color:#0f172a;\n  outline:none;\n}\n\n.login-registerPanel input[type=\"email\"]:focus,\n.login-registerPanel input[type=\"password\"]:focus,\n.login-registerPanel input[type=\"text\"]:focus{\n  border-color:#b9d4ff;\n  box-shadow:0 0 0 4px rgba(59,130,246,0.15);\n}\n\n.login-registerPreview,\n.login-registerResult{\n  display:grid;\n  gap:5px;\n  padding:11px 12px;\n  border:1px solid #dbeafe;\n  border-radius:14px;\n  background:#f8fbff;\n  overflow-wrap:anywhere;\n}\n\n.login-registerPreview strong,\n.login-registerResult a{\n  color:#1d4ed8;\n  font-weight:800;\n}\n\n.login-registerProgress{\n  padding:10px 12px;\n  border-radius:12px;\n  border:1px solid #dbeafe;\n  background:#f8fbff;\n  color:#1d4ed8;\n  font-weight:800;\n}\n\n.login-registerDone{\n  justify-items:start;\n  padding:4px 0;\n}\n\n.login-registerDone > svg{\n  width:34px;\n  height:34px;\n  color:#047857;\n}\n\n.login-registerDone h3{\n  margin:0;\n  color:#0f172a;\n  font-size:20px;\n}\n\n.login-registerDone p{\n  margin:6px 0 0;\n  color:#475569;\n  line-height:1.5;\n}\n\n@media (max-width: 560px){\n  .login-visual-band{\n    height: 312px;\n    margin: 12px;\n    border-radius: 20px;\n  }\n\n  .login-registerSteps{\n    grid-template-columns:1fr;\n  }\n\n  .login-footer,\n  .login-modal__actions{\n    align-items:stretch;\n    flex-direction:column;\n  }\n\n  .login-primary,\n  .login-secondary{\n    justify-content:center;\n    width:100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
